import { render, staticRenderFns } from "./SMSTextBoxPlaceholdersMenu.vue?vue&type=template&id=9a521226&scoped=true&"
import script from "./SMSTextBoxPlaceholdersMenu.vue?vue&type=script&lang=js&"
export * from "./SMSTextBoxPlaceholdersMenu.vue?vue&type=script&lang=js&"
import style0 from "./SMSTextBoxPlaceholdersMenu.vue?vue&type=style&index=0&id=9a521226&prod&scoped=true&lang=scss&"
import style1 from "./SMSTextBoxPlaceholdersMenu.vue?vue&type=style&index=1&id=9a521226&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a521226",
  null
  
)

export default component.exports